import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { formatBoxPlotTooltip } from "./utils";

export function translateBoxPlotResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  const { defaultSignificantFigures, useStrictRounding, uwiCoordinates, chartTypeParam } =
    states;
  const yAxisDataType = chartTypeParam?.properties?.y?.dataType;
  return {
    trigger: "item",
    confine: true,
    enterable: true,
    className: "chart-tooltip-container",
    extraCssText: "border-style:none;",
    axisPointer: { type: "cross", label: { show: true, precision: 2 } },
    show: true,

    position: function (point, _, dom) {
      const xPos = point[0];
      const yPos =
        point[1] - (dom as HTMLDivElement).offsetHeight > 48
          ? point[1] - (dom as HTMLDivElement).offsetHeight
          : 48;
      return [xPos, yPos]; //position top right of mouse cursor
    },
    formatter: (items) => {
      return formatBoxPlotTooltip(
        items,
        defaultSignificantFigures,
        useStrictRounding,
        uwiCoordinates,
        yAxisDataType
      );
    }
  };
}
